import {
  CustomExerciseType,
  Equipment,
  EquipmentFilter,
  ExerciseType,
  MuscleGroup,
  MuscleGroupFilter,
} from 'hevy-shared';

export const exerciseTypeToHuman = (type: ExerciseType): string => {
  const typeToHumanMap: { [key in ExerciseType]: string } = {
    weight_reps: 'Weight Reps',
    bodyweight_reps: 'Weighted Bodyweight',
    bodyweight_assisted_reps: 'Assisted Bodyweight',
    reps_only: 'Reps Only',
    distance_duration: 'Distance Duration',
    duration: 'Duration',
    short_distance_weight: 'Weight & Distance',
    weight_duration: 'Weight & Duration',
    floors_duration: 'Floors & Duration',
    steps_duration: 'Steps & Duration',
  };

  return typeToHumanMap[type];
};

export const customExerciseTypeToHuman = (customExerciseType: CustomExerciseType): string => {
  const customExerciseTypeToHumanMap: { [key in CustomExerciseType]: string } = {
    weight_reps: 'Weight Reps',
    bodyweight_reps: 'Weighted Bodyweight',
    bodyweight_assisted_reps: 'Assisted Bodyweight',
    reps_only: 'Reps Only',
    distance_duration: 'Distance Duration',
    duration: 'Duration',
    short_distance_weight: 'Weight & Distance',
    weight_duration: 'Weight & Duration',
  };
  return customExerciseTypeToHumanMap[customExerciseType];
};

export const equipmentToHuman = (equipment: Equipment): string => {
  const equipmentToHumanMap: { [key in Equipment]: string } = {
    none: 'None',
    machine: 'Machine',
    kettlebell: 'Kettlebell',
    barbell: 'Barbell',
    dumbbell: 'Dumbbell',
    plate: 'Plate',
    resistance_band: 'Resistance Band',
    suspension: 'Suspension',
    other: 'Other',
  };

  return equipmentToHumanMap[equipment];
};

export const equipmentFilterToHuman = (equipmentFilter: EquipmentFilter): string => {
  const equipmentFilterToHumanMap: { [key in EquipmentFilter]: string } = {
    all_equipment: 'Equipment',
    none: 'None',
    machine: 'Machine',
    kettlebell: 'Kettlebell',
    barbell: 'Barbell',
    dumbbell: 'Dumbbell',
    plate: 'Plate',
    resistance_band: 'Resistance Band',
    suspension: 'Suspension',
    other: 'Other',
  };

  return equipmentFilterToHumanMap[equipmentFilter];
};

export const muscleGroupToHuman = (muscleGroup: MuscleGroup): string => {
  const muscleGroupToHuman: { [key in MuscleGroup]: string } = {
    abdominals: 'Abdominals',
    cardio: 'Cardio',
    shoulders: 'Shoulders',
    chest: 'Chest',
    lower_back: 'Lower Back',
    full_body: 'Full Body',
    biceps: 'Biceps',
    triceps: 'Triceps',
    upper_back: 'Upper Back',
    quadriceps: 'Quadriceps',
    calves: 'Calves',
    lats: 'Lats',
    hamstrings: 'Hamstrings',
    glutes: 'Glutes',
    abductors: 'Abductors',
    adductors: 'Adductors',
    traps: 'Traps',
    forearms: 'Forearms',
    neck: 'Neck',
    other: 'Other',
  };

  return muscleGroupToHuman[muscleGroup];
};

export const muscleGroupFilterToHuman = (muscleGroupFilter: MuscleGroupFilter): string => {
  const muscleGroupFilterToHuman: { [key in MuscleGroupFilter]: string } = {
    all_muscles: 'Muscles',
    abdominals: 'Abdominals',
    cardio: 'Cardio',
    shoulders: 'Shoulders',
    chest: 'Chest',
    lower_back: 'Lower Back',
    full_body: 'Full Body',
    biceps: 'Biceps',
    triceps: 'Triceps',
    upper_back: 'Upper Back',
    quadriceps: 'Quadriceps',
    calves: 'Calves',
    lats: 'Lats',
    hamstrings: 'Hamstrings',
    glutes: 'Glutes',
    abductors: 'Abductors',
    adductors: 'Adductors',
    traps: 'Traps',
    forearms: 'Forearms',
    neck: 'Neck',
    other: 'Other',
  };

  return muscleGroupFilterToHuman[muscleGroupFilter];
};
